// import React, { useState, useEffect } from 'react';
// import { Grid, Typography, Box, ToggleButtonGroup, ToggleButton, useTheme, Select, MenuItem } from '@mui/material';
// import { FaChartLine, FaWallet, FaUsers, FaStar, FaCrown } from 'react-icons/fa';

// import ReportSummaryCards from './components/ReportSummaryCards';
// import PageContainer from 'src/components/container/PageContainer';
// import DashboardCard from 'src/components/shared/DashboardCard';
// import YearlySalesChart from './components/YearlySalesChart';
// import YearlyExpensesChart from './components/YearlyExpensesChart';
// import PerformerOfTheMonth from './components/PerformerOfTheMonth';
// import StaffPerformanceMonthlyView from './components/StaffPerformanceTable'; // Renamed for clarity
// import TopAnalyticsCard from './components/TopAnalyticsCard';
// import TopMembershipPackageAnalytics from './components/TopMembershipPackageAnalytics';
// import { useMain } from 'src/views/hooks/useMain';
// import ShowLoader from 'src/components/CustomComponents/ShowLoader';
// const Reports = () => {
//   const theme = useTheme();
//   // function stringToColor(string) {
//   //   if (!string) {
//   //     return '#000000'; // Return a default color if string is undefined or null
//   //   }

//   //   let hash = 0;
//   //   let i;

//   //   /* eslint-disable no-bitwise */
//   //   for (i = 0; i < string.length; i += 1) {
//   //     hash = string.charCodeAt(i) + ((hash << 5) - hash);
//   //   }

//   //   let color = '#';

//   //   for (i = 0; i < 3; i += 1) {
//   //     const value = (hash >> (i * 8)) & 0xff;
//   //     color += `00${value.toString(16)}`.slice(-2);
//   //   }
//   //   /* eslint-enable no-bitwise */

//   //   return color;
//   // }
//   const {
//     monthwisesalesreport,
//     monthwiseexpensereport,
//     topperformer,
//     staffperformance,
//     topserviceproducts,
//     topmembershippackages,
//     activeBranchId,
//   } = useMain();
//   const [reportsData, setReportsData] = useState({
//     staffPerformance: [],
//     sales: [],
//     expenses: [],
//     staffMonthlyPerformance: [],
//     monthlyAnalytics: [],
//     membershipPackageAnalytics: [],
//     totalYearlySales: 0,
//     totalYearlyExpenses: 0,
//     year: new Date().getFullYear()
//   });
//   const [loading, setLoading] = useState(true);
//   const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
//   const [selectedMembershipPackageMonth, setSelectedMembershipPackageMonth] = useState(new Date().getMonth() + 1);
//   const [selectedAnalyticsMonth, setSelectedAnalyticsMonth] = useState(new Date().getMonth() + 1);

//   // You would get the branchId from your state management (Redux, Context, etc.)
//   const branchId = activeBranchId; 

//   useEffect(() => {
//     const fetchYearlyData = async () => {
//       setLoading(true);
//       // Fetch yearly data from API
//       const salesReport = await monthwisesalesreport(branchId, reportsData.year);
//       const expenseReport = await monthwiseexpensereport(branchId, reportsData.year);
//       const staffPerformanceReport = await staffperformance(branchId, reportsData.year);
//       const topPerformerReport = await topperformer(branchId, reportsData.year);
//       const topServiceProductsReport = await topserviceproducts(branchId, reportsData.year);
//       const topMembershipPackagesReport = await topmembershippackages(branchId, reportsData.year);
//       // Commented out dummy sales data
//       /*
//       const mockSalesData = {
//         year: 2025,
//         branchId: '659655d23556b071792c5de7',
//         totalYearlySales: 2181026.5,
//         sales: [
//           {
//             month: 1,
//             totalSales: 156291.5,
//             difference: 0,
//             percentageChange: 0,
//           },
//           {
//             month: 2,
//             totalSales: 235345,
//             difference: 79053.5,
//             percentageChange: 50.58,
//           },
//           {
//             month: 3,
//             totalSales: 50808,
//             difference: -184537,
//             percentageChange: -78.41,
//           },
//           {
//             month: 4,
//             totalSales: 69543,
//             difference: 18735,
//             percentageChange: 36.87,
//           },
//           {
//             month: 5,
//             totalSales: 357015,
//             difference: 287472,
//             percentageChange: 413.37,
//           },
//           {
//             month: 6,
//             totalSales: 418942,
//             difference: 61927,
//             percentageChange: 17.35,
//           },
//           { month: 7, totalSales: 319806, difference: -99136, percentageChange: -23.66 },
//           { month: 8, totalSales: 155777, difference: -164029, percentageChange: -51.29 },
//           { month: 9, totalSales: 229325, difference: 73548, percentageChange: 47.21 },
//           { month: 10, totalSales: 132946, difference: -96379, percentageChange: -42.03 },
//           { month: 11, totalSales: 52703, difference: -80243, percentageChange: -60.36 },
//           { month: 12, totalSales: 2525, difference: -50178, percentageChange: -95.21 },
//         ],
//       };
//       */

//       /*
//       const mockExpensesData = {
//         totalYearlyExpenses: 26728,
//         expenses: [
//             { month: 1, totalExpenses: 15000, difference: 0, percentageChange: 0 },
//             { month: 2, totalExpenses: 18000, difference: 3000, percentageChange: 20.0 },
//             { month: 3, totalExpenses: 16000, difference: -2000, percentageChange: -11.11 },
//             { month: 4, totalExpenses: 20000, difference: 4000, percentageChange: 25.0 },
//             { month: 5, totalExpenses: 19000, difference: -1000, percentageChange: -5.0 },
//             { month: 6, totalExpenses: 22000, difference: 3000, percentageChange: 15.79 },
//             { month: 7, totalExpenses: 21000, difference: -1000, percentageChange: -4.55 },
//             { month: 8, totalExpenses: 25000, difference: 4000, percentageChange: 19.05 },
//             { month: 9, totalExpenses: 23000, difference: -2000, percentageChange: -8.0 },
//             { month: 10, totalExpenses: 26000, difference: 3000, percentageChange: 13.04 },
//             { month: 11, totalExpenses: 24000, difference: -2000, percentageChange: -7.69 },
//             { month: 12, totalExpenses: 28000, difference: 4000, percentageChange: 16.67 },
//         ]
//       };
//       */

//       /*
//       const mockStaffData = {
//         staffPerformance: [
//             { staffName: 'Happy', totalYearWork: 334322.915 },
//             { staffName: 'Kirtika', totalYearWork: 89620.125 },
//             { staffName: 'Ayush Sharma', totalYearWork: 467553.64 },
//         ]
//       };

//       */
//       /*
//       const mockStaffMonthlyPerformance = {
//         "year": 2025,
//         "staffPerformance": [
//             {
//                 "staffId": "661e7ad40455e172d7fd5de7",
//                 "monthly": [
//                     { "month": 1, "totalServiceAmount": 150, "totalProductAmount": 0, "totalWorkAmount": 150, "monthlyIncentiveAmount": 0 },
//                     { "month": 2, "totalServiceAmount": 4018, "totalProductAmount": 141241.2, "totalWorkAmount": 145259.2, "monthlyIncentiveAmount": 30 },
//                     { "month": 3, "totalServiceAmount": 2200, "totalProductAmount": 0, "totalWorkAmount": 2200, "monthlyIncentiveAmount": 4 },
//                     { "month": 4, "totalServiceAmount": 9460, "totalProductAmount": 0, "totalWorkAmount": 9460, "monthlyIncentiveAmount": 0 },
//                     { "month": 5, "totalServiceAmount": 3880, "totalProductAmount": 3438, "totalWorkAmount": 7318, "monthlyIncentiveAmount": 1699 },
//                     { "month": 6, "totalServiceAmount": 16604, "totalProductAmount": 347, "totalWorkAmount": 16951, "monthlyIncentiveAmount": 9.98 },
//                     { "month": 7, "totalServiceAmount": 50223.86, "totalProductAmount": 0, "totalWorkAmount": 50223.86, "monthlyIncentiveAmount": 0 },
//                     { "month": 8, "totalServiceAmount": 25345.5, "totalProductAmount": 0, "totalWorkAmount": 25345.5, "monthlyIncentiveAmount": 0 },
//                     { "month": 9, "totalServiceAmount": 40538.575, "totalProductAmount": 422.88, "totalWorkAmount": 40961.454999999994, "monthlyIncentiveAmount": 0 },
//                     { "month": 10, "totalServiceAmount": 25539.5, "totalProductAmount": 0, "totalWorkAmount": 25539.5, "monthlyIncentiveAmount": 0 },
//                     { "month": 11, "totalServiceAmount": 10764.4, "totalProductAmount": 150, "totalWorkAmount": 10914.4, "monthlyIncentiveAmount": 0 },
//                     { "month": 12, "totalServiceAmount": 0, "totalProductAmount": 0, "totalWorkAmount": 0, "monthlyIncentiveAmount": 0 }
//                 ],
//                 "totalYearWork": 334322.915,
//                 "totalYearIncentive": 1742.98,
//                 "staffName": "happy"
//             },
//             {
//                 "staffId": "662a5b7ed9da7d00a8895c4d",
//                 "monthly": [
//                     { "month": 1, "totalServiceAmount": 2410, "totalProductAmount": 0, "totalWorkAmount": 2410, "monthlyIncentiveAmount": 70 },
//                     { "month": 2, "totalServiceAmount": 2448.06, "totalProductAmount": 25000, "totalWorkAmount": 27448.06, "monthlyIncentiveAmount": 60 },
//                     { "month": 3, "totalServiceAmount": 1549, "totalProductAmount": 0, "totalWorkAmount": 1549, "monthlyIncentiveAmount": 80 },
//                     { "month": 4, "totalServiceAmount": 730, "totalProductAmount": 192, "totalWorkAmount": 922, "monthlyIncentiveAmount": 64 },
//                     { "month": 5, "totalServiceAmount": 1650, "totalProductAmount": 0, "totalWorkAmount": 1650, "monthlyIncentiveAmount": 20 },
//                     { "month": 6, "totalServiceAmount": 4550, "totalProductAmount": 1650, "totalWorkAmount": 6200, "monthlyIncentiveAmount": 77.5 },
//                     { "month": 7, "totalServiceAmount": 16789.45, "totalProductAmount": 0, "totalWorkAmount": 16789.45, "monthlyIncentiveAmount": 273.333 },
//                     { "month": 8, "totalServiceAmount": 5085, "totalProductAmount": 2400, "totalWorkAmount": 7485, "monthlyIncentiveAmount": 128.333 },
//                     { "month": 9, "totalServiceAmount": 10364.575, "totalProductAmount": 100, "totalWorkAmount": 10464.575, "monthlyIncentiveAmount": 162.5 },
//                     { "month": 10, "totalServiceAmount": 11506, "totalProductAmount": 1268.6399999999999, "totalWorkAmount": 12774.64, "monthlyIncentiveAmount": 175 },
//                     { "month": 11, "totalServiceAmount": 877.4, "totalProductAmount": 0, "totalWorkAmount": 877.4, "monthlyIncentiveAmount": 40.253 },
//                     { "month": 12, "totalServiceAmount": 1050, "totalProductAmount": 0, "totalWorkAmount": 1050, "monthlyIncentiveAmount": 20 }
//                 ],
//                 "totalYearWork": 89620.125,
//                 "totalYearIncentive": 1170.9189999999999,
//                 "staffName": "kirtika"
//             },
//             {
//                 "staffId": "6619284bfed1947fd29f263f",
//                 "monthly": [
//                     { "month": 1, "totalServiceAmount": 2500, "totalProductAmount": 0, "totalWorkAmount": 2500, "monthlyIncentiveAmount": 0 },
//                     { "month": 2, "totalServiceAmount": 800, "totalProductAmount": 0, "totalWorkAmount": 800, "monthlyIncentiveAmount": 0 },
//                     // staffName is missing here, which causes the crash. I'll add a placeholder.
//                     { "month": 3, "totalServiceAmount": 0, "totalProductAmount": 0, "totalWorkAmount": 0, "monthlyIncentiveAmount": 0 }, 
//                     { "month": 4, "totalServiceAmount": 0, "totalProductAmount": 0, "totalWorkAmount": 0, "monthlyIncentiveAmount": 0 },
//                     { "month": 5, "totalServiceAmount": 0, "totalProductAmount": 0, "totalWorkAmount": 0, "monthlyIncentiveAmount": 0 },
//                     { "month": 6, "totalServiceAmount": 0, "totalProductAmount": 0, "totalWorkAmount": 0, "monthlyIncentiveAmount": 0 },
//                     { "month": 7, "totalServiceAmount": 0, "totalProductAmount": 0, "totalWorkAmount": 0, "monthlyIncentiveAmount": 0 },
//                     { "month": 8, "totalServiceAmount": 0, "totalProductAmount": 0, "totalWorkAmount": 0, "monthlyIncentiveAmount": 0 },
//                     { "month": 9, "totalServiceAmount": 0, "totalProductAmount": 0, "totalWorkAmount": 0, "monthlyIncentiveAmount": 0 },
//                     { "month": 10, "totalServiceAmount": 0, "totalProductAmount": 0, "totalWorkAmount": 0, "monthlyIncentiveAmount": 0 },
//                     { "month": 11, "totalServiceAmount": 0, "totalProductAmount": 0, "totalWorkAmount": 0, "monthlyIncentiveAmount": 0 },
//                     { "month": 12, "totalServiceAmount": 0, "totalProductAmount": 0, "totalWorkAmount": 0, "monthlyIncentiveAmount": 0 }
//                 ],
//                 "totalYearWork": 3300,
//                 "totalYearIncentive": 0,
//                 "staffName": "Unknown Staff"
//             },
//             {
//                 "staffId": "65eff161f4f48f0bc36232da",
//                 "monthly": [
//                     { "month": 1, "totalServiceAmount": 1600, "totalProductAmount": 0, "totalWorkAmount": 1600, "monthlyIncentiveAmount": 0 },
//                     { "month": 2, "totalServiceAmount": 2050, "totalProductAmount": 0, "totalWorkAmount": 2050, "monthlyIncentiveAmount": 0 },
//                     { "month": 3, "totalServiceAmount": 9000, "totalProductAmount": 0, "totalWorkAmount": 9000, "monthlyIncentiveAmount": 0 },
//                     { "month": 4, "totalServiceAmount": 2690, "totalProductAmount": 0, "totalWorkAmount": 2690, "monthlyIncentiveAmount": 0 },
//                     { "month": 5, "totalServiceAmount": 1138, "totalProductAmount": 90620.8, "totalWorkAmount": 91758.8, "monthlyIncentiveAmount": 33 },
//                     { "month": 6, "totalServiceAmount": 21588.3, "totalProductAmount": 2369.15, "totalWorkAmount": 23957.45, "monthlyIncentiveAmount": 115 },
//                     { "month": 7, "totalServiceAmount": 69958.26, "totalProductAmount": 0, "totalWorkAmount": 69958.26, "monthlyIncentiveAmount": 0 },
//                     { "month": 8, "totalServiceAmount": 47296.5, "totalProductAmount": 0, "totalWorkAmount": 47296.5, "monthlyIncentiveAmount": 0 },
//                     { "month": 9, "totalServiceAmount": 87329.75, "totalProductAmount": 0, "totalWorkAmount": 87329.75, "monthlyIncentiveAmount": 0 },
//                     { "month": 10, "totalServiceAmount": 90107, "totalProductAmount": 422.88, "totalWorkAmount": 90529.88, "monthlyIncentiveAmount": 0 },
//                     { "month": 11, "totalServiceAmount": 41373, "totalProductAmount": 0, "totalWorkAmount": 41373, "monthlyIncentiveAmount": 0 },
//                     { "month": 12, "totalServiceAmount": 10, "totalProductAmount": 0, "totalWorkAmount": 10, "monthlyIncentiveAmount": 0 }
//                 ],
//                 "totalYearWork": 467553.64,
//                 "totalYearIncentive": 148,
//                 "staffName": "Ayush Sharma "
//             },
//             {
//                 "staffId": "667fb31f6dfac48380a83735",
//                 "monthly": [
//                     { "month": 1, "totalServiceAmount": 0, "totalProductAmount": 48, "totalWorkAmount": 48, "monthlyIncentiveAmount": 4 },
//                     { "month": 2, "totalServiceAmount": 3341.6, "totalProductAmount": 0, "totalWorkAmount": 3341.6, "monthlyIncentiveAmount": 0 },
//                     { "month": 3, "totalServiceAmount": 60, "totalProductAmount": 0, "totalWorkAmount": 60, "monthlyIncentiveAmount": 0 },
//                     { "month": 4, "totalServiceAmount": 600, "totalProductAmount": 0, "totalWorkAmount": 600, "monthlyIncentiveAmount": 0 },
//                     { "month": 5, "totalServiceAmount": 2350, "totalProductAmount": 0, "totalWorkAmount": 2350, "monthlyIncentiveAmount": 0 },
//                     { "month": 6, "totalServiceAmount": 2270, "totalProductAmount": 1005, "totalWorkAmount": 3275, "monthlyIncentiveAmount": 50.25 },
//                     { "month": 7, "totalServiceAmount": 50, "totalProductAmount": 200, "totalWorkAmount": 250, "monthlyIncentiveAmount": 100 },
//                     { "month": 8, "totalServiceAmount": 0, "totalProductAmount": 0, "totalWorkAmount": 0, "monthlyIncentiveAmount": 0 },
//                     { "month": 9, "totalServiceAmount": 0, "totalProductAmount": 0, "totalWorkAmount": 0, "monthlyIncentiveAmount": 0 },
//                     { "month": 10, "totalServiceAmount": 0, "totalProductAmount": 0, "totalWorkAmount": 0, "monthlyIncentiveAmount": 0 },
//                     { "month": 11, "totalServiceAmount": 0, "totalProductAmount": 0, "totalWorkAmount": 0, "monthlyIncentiveAmount": 0 },
//                     { "month": 12, "totalServiceAmount": 0, "totalProductAmount": 0, "totalWorkAmount": 0, "monthlyIncentiveAmount": 0 }
//                 ],
//                 "totalYearWork": 9924.6,
//                 "totalYearIncentive": 154.25,
//                 "staffName": "raj"
//             },
//             {
//                 "staffId": "67a20afc14c6c1ff5163a85f",
//                 "monthly": [
//                     { "month": 1, "totalServiceAmount": 0, "totalProductAmount": 0, "totalWorkAmount": 0, "monthlyIncentiveAmount": 0 },
//                     { "month": 2, "totalServiceAmount": 0, "totalProductAmount": 0, "totalWorkAmount": 0, "monthlyIncentiveAmount": 0 },
//                     { "month": 3, "totalServiceAmount": 2200, "totalProductAmount": 0, "totalWorkAmount": 2200, "monthlyIncentiveAmount": 0 },
//                     { "month": 4, "totalServiceAmount": 900, "totalProductAmount": 720, "totalWorkAmount": 1620, "monthlyIncentiveAmount": 4 },
//                     { "month": 5, "totalServiceAmount": 300, "totalProductAmount": 17582.4, "totalWorkAmount": 17882.4, "monthlyIncentiveAmount": 0 },
//                     { "month": 6, "totalServiceAmount": 1959, "totalProductAmount": 48, "totalWorkAmount": 2007, "monthlyIncentiveAmount": 4 },
//                     { "month": 7, "totalServiceAmount": 1140, "totalProductAmount": 760.5, "totalWorkAmount": 1900.5, "monthlyIncentiveAmount": 209.725 },
//                     { "month": 8, "totalServiceAmount": 0, "totalProductAmount": 38.4, "totalWorkAmount": 38.4, "monthlyIncentiveAmount": 4 },
//                     { "month": 9, "totalServiceAmount": 0, "totalProductAmount": 0, "totalWorkAmount": 0, "monthlyIncentiveAmount": 0 },
//                     { "month": 10, "totalServiceAmount": 0, "totalProductAmount": 0, "totalWorkAmount": 0, "monthlyIncentiveAmount": 0 },
//                     { "month": 11, "totalServiceAmount": 0, "totalProductAmount": 0, "totalWorkAmount": 0, "monthlyIncentiveAmount": 0 },
//                     { "month": 12, "totalServiceAmount": 0, "totalProductAmount": 0, "totalWorkAmount": 0, "monthlyIncentiveAmount": 0 }
//                 ],
//                 "totalYearWork": 25648.300000000003,
//                 "totalYearIncentive": 221.725,
//                 "staffName": "Ayush ji"
//             },
//             {
//                 "staffId": "667bac8f592ba61729e723de",
//                 "monthly": [
//                     { "month": 1, "totalServiceAmount": 1050, "totalProductAmount": 96, "totalWorkAmount": 1146, "monthlyIncentiveAmount": 8 },
//                     { "month": 2, "totalServiceAmount": 60, "totalProductAmount": 0, "totalWorkAmount": 60, "monthlyIncentiveAmount": 0 },
//                     { "month": 3, "totalServiceAmount": 1220, "totalProductAmount": 0, "totalWorkAmount": 1220, "monthlyIncentiveAmount": 0 },
//                     { "month": 4, "totalServiceAmount": 500, "totalProductAmount": 0, "totalWorkAmount": 500, "monthlyIncentiveAmount": 0 },
//                     { "month": 5, "totalServiceAmount": 10759, "totalProductAmount": 0, "totalWorkAmount": 10759, "monthlyIncentiveAmount": 0 },
//                     { "month": 6, "totalServiceAmount": 3907, "totalProductAmount": 248, "totalWorkAmount": 4155, "monthlyIncentiveAmount": 104 },
//                     { "month": 7, "totalServiceAmount": 510, "totalProductAmount": 200, "totalWorkAmount": 710, "monthlyIncentiveAmount": 4 },
//                     { "month": 8, "totalServiceAmount": 0, "totalProductAmount": 0, "totalWorkAmount": 0, "monthlyIncentiveAmount": 0 },
//                     { "month": 9, "totalServiceAmount": 4000, "totalProductAmount": 0, "totalWorkAmount": 4000, "monthlyIncentiveAmount": 0 },
//                     { "month": 10, "totalServiceAmount": 0, "totalProductAmount": 0, "totalWorkAmount": 0, "monthlyIncentiveAmount": 0 },
//                     { "month": 11, "totalServiceAmount": 0, "totalProductAmount": 0, "totalWorkAmount": 0, "monthlyIncentiveAmount": 0 },
//                     { "month": 12, "totalServiceAmount": 0, "totalProductAmount": 0, "totalWorkAmount": 0, "monthlyIncentiveAmount": 0 }
//                 ],
//                 "totalYearWork": 22550,
//                 "totalYearIncentive": 116,
//                 "staffName": "tyagiji"
//             },
//             {
//                 "staffId": "6762e2a0b7b0a54da7a829da",
//                 "monthly": [
//                     { "month": 1, "totalServiceAmount": 750, "totalProductAmount": 0, "totalWorkAmount": 750, "monthlyIncentiveAmount": 0 },
//                     { "month": 2, "totalServiceAmount": 8420, "totalProductAmount": 0, "totalWorkAmount": 8420, "monthlyIncentiveAmount": 962 },
//                     { "month": 3, "totalServiceAmount": 570, "totalProductAmount": 800, "totalWorkAmount": 1370, "monthlyIncentiveAmount": 113 },
//                     { "month": 4, "totalServiceAmount": 8950, "totalProductAmount": 43.2, "totalWorkAmount": 8993.2, "monthlyIncentiveAmount": 899 },
//                     { "month": 5, "totalServiceAmount": 15170, "totalProductAmount": 85141.08, "totalWorkAmount": 100311.08, "monthlyIncentiveAmount": 2291076.5 },
//                     { "month": 6, "totalServiceAmount": 20811, "totalProductAmount": 600, "totalWorkAmount": 21411, "monthlyIncentiveAmount": 1856.05 },
//                     { "month": 7, "totalServiceAmount": 3360, "totalProductAmount": 90, "totalWorkAmount": 3450, "monthlyIncentiveAmount": 71.25 },
//                     { "month": 8, "totalServiceAmount": 2596, "totalProductAmount": 289, "totalWorkAmount": 2885, "monthlyIncentiveAmount": 309.6 },
//                     { "month": 9, "totalServiceAmount": 7669, "totalProductAmount": 5200, "totalWorkAmount": 12869, "monthlyIncentiveAmount": 3546.9 },
//                     { "month": 10, "totalServiceAmount": 0, "totalProductAmount": 0, "totalWorkAmount": 0, "monthlyIncentiveAmount": 0 },
//                     { "month": 11, "totalServiceAmount": 530, "totalProductAmount": 150, "totalWorkAmount": 680, "monthlyIncentiveAmount": 53 },
//                     { "month": 12, "totalServiceAmount": 490, "totalProductAmount": 0, "totalWorkAmount": 490, "monthlyIncentiveAmount": 49 }
//                 ],
//                 "totalYearWork": 161629.28000000003,
//                 "totalYearIncentive": 2298936.3,
//                 "staffName": "Arpit"
//             },
//             {
//                 "staffId": "66386d66375f101460450d58",
//                 "monthly": [
//                     { "month": 1, "totalServiceAmount": 2500, "totalProductAmount": 48, "totalWorkAmount": 2548, "monthlyIncentiveAmount": 4 },
//                     { "month": 2, "totalServiceAmount": 1934, "totalProductAmount": 0, "totalWorkAmount": 1934, "monthlyIncentiveAmount": 0 },
//                     { "month": 3, "totalServiceAmount": 0, "totalProductAmount": 0, "totalWorkAmount": 0, "monthlyIncentiveAmount": 0 },
//                     { "month": 4, "totalServiceAmount": 7950, "totalProductAmount": 600, "totalWorkAmount": 8550, "monthlyIncentiveAmount": 6 },
//                     { "month": 5, "totalServiceAmount": 2950, "totalProductAmount": 38, "totalWorkAmount": 2988, "monthlyIncentiveAmount": 4 },
//                     { "month": 6, "totalServiceAmount": 17150, "totalProductAmount": 0, "totalWorkAmount": 17150, "monthlyIncentiveAmount": 0 },
//                     { "month": 7, "totalServiceAmount": 3946.5, "totalProductAmount": 139, "totalWorkAmount": 4085.5, "monthlyIncentiveAmount": 6.95 },
//                     { "month": 8, "totalServiceAmount": 900, "totalProductAmount": 900, "totalWorkAmount": 1800, "monthlyIncentiveAmount": 72 },
//                     { "month": 9, "totalServiceAmount": 3010.41, "totalProductAmount": 0, "totalWorkAmount": 3010.41, "monthlyIncentiveAmount": 0 },
//                     { "month": 10, "totalServiceAmount": 2851.5, "totalProductAmount": 0, "totalWorkAmount": 2851.5, "monthlyIncentiveAmount": 0 },
//                     { "month": 11, "totalServiceAmount": 2858, "totalProductAmount": 0, "totalWorkAmount": 2858, "monthlyIncentiveAmount": 0 },
//                     { "month": 12, "totalServiceAmount": 0, "totalProductAmount": 0, "totalWorkAmount": 0, "monthlyIncentiveAmount": 0 }
//                 ],
//                 "totalYearWork": 47775.41,
//                 "totalYearIncentive": 92.95,
//                 "staffName": "shobhitji"
//             }
//         ]
//     };

//     const mockMonthlyAnalytics = {
//       "year": 2025,
//       "monthlyAnalytics": [ // This now contains service/product analytics
//         {
//           "month": 1,
//           "service": { "serviceId": "6597c38a3cc5000443239af0", "serviceName": "Shampoo Styling", "usageCount": 4, "totalAmount": 4600, "totalMonthlyServiceAmount": 15792.5, "percentageContribution": 29.13 },
//           "product": { "productId": "661f4a646f497a2b7b42ee3a", "productName": "Godrej hair color", "usageCount": 1, "totalAmount": 800, "totalMonthlyProductAmount": 1088, "percentageContribution": 73.53 }
//         },
//         {
//           "month": 2,
//           "service": { "serviceId": "6597c38a3cc5000443239af0", "serviceName": "Shampoo Styling", "usageCount": 8, "totalAmount": 14274, "totalMonthlyServiceAmount": 37740.8, "percentageContribution": 37.82 },
//           "product": { "productId": "67c03ef714c6c1ff5169fbb8", "productName": "Medallion DX 555", "usageCount": 1, "totalAmount": 140000, "totalMonthlyProductAmount": 166241.2, "percentageContribution": 84.21 }
//         },
//         {
//           "month": 3,
//           "service": { "serviceId": "6597c38a3cc5000443239aed", "serviceName": "Haircut", "usageCount": 4, "totalAmount": 9750, "totalMonthlyServiceAmount": 31159, "percentageContribution": 31.29 },
//           "product": { "productId": "661f4a646f497a2b7b42ee3a", "productName": "Godrej hair color", "usageCount": 1, "totalAmount": 800, "totalMonthlyProductAmount": 800, "percentageContribution": 100 }
//         },
//         {
//           "month": 4,
//           "service": { "serviceId": "6597c38a3cc5000443239aed", "serviceName": "Haircut", "usageCount": 6, "totalAmount": 28875, "totalMonthlyServiceAmount": 41660.5, "percentageContribution": 69.31 },
//           "product": { "productId": "6629f5c6253af51c963c8c63", "productName": "garniar fashwash", "usageCount": 1, "totalAmount": 720, "totalMonthlyProductAmount": 1840.8, "percentageContribution": 39.11 }
//         },
//         {
//           "month": 5,
//           "service": { "serviceId": "662b96749a83955d19c8d86b", "serviceName": "Yearly Subscription Plan", "usageCount": 3, "totalAmount": 22400, "totalMonthlyServiceAmount": 73164.1, "percentageContribution": 30.62 },
//           "product": { "productId": "661f4a646f497a2b7b42ee3a", "productName": "Godrej hair color", "usageCount": 1, "totalAmount": 90000, "totalMonthlyProductAmount": 229492.28, "percentageContribution": 39.22 }
//         },
//         {
//           "month": 6,
//           "service": { "serviceId": "6597c38a3cc5000443239aec", "serviceName": "Director Hair Cut", "usageCount": 51, "totalAmount": 142255, "totalMonthlyServiceAmount": 316933.87, "percentageContribution": 44.88 },
//           "product": { "productId": "6842beb9ab74d20915668089", "productName": "mama earth facewash", "usageCount": 2, "totalAmount": 23990, "totalMonthlyProductAmount": 36639.43, "percentageContribution": 65.48 }
//         },
//         {
//           "month": 7,
//           "service": { "serviceId": "662b96749a83955d19c8d86b", "serviceName": "Yearly Subscription Plan", "usageCount": 10, "totalAmount": 77000, "totalMonthlyServiceAmount": 223943.07, "percentageContribution": 34.38 },
//           "product": { "productId": "6842beb9ab74d20915668089", "productName": "mama earth facewash", "usageCount": 6, "totalAmount": 1130, "totalMonthlyProductAmount": 3125.43, "percentageContribution": 36.16 }
//         },
//         {
//           "month": 8,
//           "service": { "serviceId": "6597c38a3cc5000443239af0", "serviceName": "Shampoo Styling", "usageCount": 22, "totalAmount": 27015, "totalMonthlyServiceAmount": 90738, "percentageContribution": 29.77 },
//           "product": { "productId": "6895c313513ab76d4ce1550e", "productName": "Rohit ji facewash", "usageCount": 1, "totalAmount": 16000, "totalMonthlyProductAmount": 19627.4, "percentageContribution": 81.52 }
//         },
//         {
//           "month": 9,
//           "service": { "serviceId": "662b96749a83955d19c8d86b", "serviceName": "Yearly Subscription Plan", "usageCount": 12, "totalAmount": 72000, "totalMonthlyServiceAmount": 163174.66, "percentageContribution": 44.12 },
//           "product": { "productId": "68d6433535ef5862f6914057", "productName": "streeks serum", "usageCount": 4, "totalAmount": 5200, "totalMonthlyProductAmount": 6161.76, "percentageContribution": 84.39 }
//         },
//         {
//           "month": 10,
//           "service": { "serviceId": "662b96749a83955d19c8d86b", "serviceName": "Yearly Subscription Plan", "usageCount": 9, "totalAmount": 74000, "totalMonthlyServiceAmount": 133404, "percentageContribution": 55.47 },
//           "product": { "productId": "6827410d67be28c1d16ca369", "productName": "Recode Keratin Shampoo", "usageCount": 2, "totalAmount": 1268.6399999999999, "totalMonthlyProductAmount": 1787.52, "percentageContribution": 70.97 }
//         },
//         {
//           "month": 11,
//           "service": { "serviceId": "69099f17bdfa24e821ccbfe5", "serviceName": "2 Year Subscription", "usageCount": 1, "totalAmount": 12000, "totalMonthlyServiceAmount": 56702.8, "percentageContribution": 21.16 },
//           "product": { "productId": "6827410d67be28c1d16ca369", "productName": "Recode Keratin Shampoo", "usageCount": 1, "totalAmount": 422.88, "totalMonthlyProductAmount": 722.88, "percentageContribution": 58.5 }
//         },
//         {
//           "month": 12,
//           "service": { "serviceId": "66742673c6c78eede6ac0213", "serviceName": "Haircut", "usageCount": 2, "totalAmount": 1000, "totalMonthlyServiceAmount": 1550, "percentageContribution": 64.52 },
//           "product": null
//         }
//       ]
//     };

//     const mockMembershipPackageAnalytics = {
//       "year": 2025,
//       "monthlyAnalytics": [
//         {
//           "month": 1,
//           "membership": { "membershipId": "67569407b7b0a54da7a66206", "membershipName": "Membership", "usageCount": 7, "totalAmount": 117519, "percentageContribution": 98.33 },
//           "package": { "packageId": "677be881484daf2724686454", "packageName": "Package", "usageCount": 5, "totalAmount": 8170, "percentageContribution": 47.42 }
//         },
//         {
//           "month": 2,
//           "membership": { "membershipId": "67ad9b7c14c6c1ff51660ef0", "membershipName": "Membership", "usageCount": 1, "totalAmount": 12000, "percentageContribution": 72.93 },
//           "package": { "packageId": "67bdaeeb14c6c1ff51699531", "packageName": "Package", "usageCount": 1, "totalAmount": 999, "percentageContribution": 100 }
//         },
//         {
//           "month": 3,
//           "membership": { "membershipId": "67ad9b7c14c6c1ff51660ef0", "membershipName": "Membership", "usageCount": 1, "totalAmount": 12000, "percentageContribution": 100 },
//           "package": { "packageId": "67bdaeeb14c6c1ff51699531", "packageName": "Package", "usageCount": 1, "totalAmount": 999, "percentageContribution": 100 }
//         },
//         {
//           "month": 4,
//           "membership": { "membershipId": "67ad9b7c14c6c1ff51660ef0", "membershipName": "Membership", "usageCount": 2, "totalAmount": 24000, "percentageContribution": 90.23 },
//           "package": null
//         },
//         {
//           "month": 5,
//           "membership": { "membershipId": "67fce6a6d48c68241e4baff8", "membershipName": "Membership", "usageCount": 2, "totalAmount": 4000, "percentageContribution": 31.51 },
//           "package": { "packageId": "68304eaeab74d209156284df", "packageName": "Package", "usageCount": 4, "totalAmount": 5196, "percentageContribution": 36.25 }
//         },
//         {
//           "month": 6,
//           "membership": { "membershipId": "6842c9b1ab74d20915668622", "membershipName": "Membership", "usageCount": 2, "totalAmount": 21000, "percentageContribution": 39.46 },
//           "package": { "packageId": "685d3847c16f5c2d7f57ade0", "packageName": "Package", "usageCount": 1, "totalAmount": 10000, "percentageContribution": 86.96 }
//         },
//         {
//           "month": 7,
//           "membership": { "membershipId": "6868e71ef43266efbc42b859", "membershipName": "Membership", "usageCount": 1, "totalAmount": 12000, "percentageContribution": 12.2 },
//           "package": { "packageId": "687b3edb2ca122fdabb7afad", "packageName": "Package", "usageCount": 1, "totalAmount": 26100, "percentageContribution": 43.98 }
//         },
//         {
//           "month": 8,
//           "membership": { "membershipId": "6895dc7f513ab76d4ce17280", "membershipName": "ILLUM Unisex Salon", "usageCount": 1, "totalAmount": 12000, "percentageContribution": 37.98 },
//           "package": { "packageId": "689b0cec513ab76d4ce37f06", "packageName": "P-1999", "usageCount": 2, "totalAmount": 3998, "percentageContribution": 72.72 }
//         },
//         {
//           "month": 9,
//           "membership": { "membershipId": "68c9038d784fedae76d6ce3d", "membershipName": "testing 16th", "usageCount": 4, "totalAmount": 32000, "percentageContribution": 57.14 },
//           "package": null
//         },
//         {
//           "month": 10,
//           "membership": { "membershipId": "68c9038d784fedae76d6ce3d", "membershipName": "testing 16th", "usageCount": 3, "totalAmount": 18000, "percentageContribution": 83.72 },
//           "package": { "packageId": "68cd2fcb9c9ce2038dfa0a43", "packageName": "dagla hair studio", "usageCount": 3, "totalAmount": 12000, "percentageContribution": 32.12 }
//         },
//         {
//           "month": 11,
//           "membership": null,
//           "package": { "packageId": "68cd2fcb9c9ce2038dfa0a43", "packageName": "dagla hair studio", "usageCount": 1, "totalAmount": 5000, "percentageContribution": 100 }
//         },
//         {
//           "month": 12,
//           "membership": { "membershipId": "68c7c3fd915bcbeb8775b274", "membershipName": "Sakhi beauty Salon", "usageCount": 1, "totalAmount": 1000, "percentageContribution": 100 },
//           "package": null
//         }
//       ]
//     };
//     */

//       setReportsData({
//     staffPerformance: topPerformerReport?.data?.staffPerformance || [],
//         sales: salesReport?.data?.sales || [],
//         expenses: expenseReport?.data?.expenses || [],
//         staffMonthlyPerformance: staffPerformanceReport?.data?.staffPerformance || [],
//         monthlyAnalytics: topServiceProductsReport?.data?.monthlyAnalytics || [],
//         membershipPackageAnalytics: topMembershipPackagesReport?.data?.monthlyAnalytics || [],
//         totalYearlySales: salesReport?.data?.totalYearlySales || 0,
//         totalYearlyExpenses: expenseReport?.data?.totalYearlyExpenses || 0,
//         year: salesReport?.data?.year || new Date().getFullYear(),
//       });

//       setLoading(false);
//     };
//     fetchYearlyData();
//   }, [branchId, reportsData.year]);

//   useEffect(() => {
//     const fetchMonthlyData = async () => {
//       const topPerformerReport = await topperformer(branchId, reportsData.year, selectedMonth);
//       setReportsData(prev => ({
//         ...prev,
//         staffPerformance: topPerformerReport?.data?.staffPerformance || [],
//       }));
//     };
//     fetchMonthlyData();
//   }, [branchId, reportsData.year, selectedMonth]);

//   const monthNames = [
//    'Jan',
//     'Feb',
//     'Mar',
//     'Apr',
//     'May',
//     'Jun',
//     'Jul',
//     'Aug',
//     'Sep',
//     'Oct',
//     'Nov',
//     'Dec',
//   ];

//   const totalStaffWork = reportsData.staffMonthlyPerformance.reduce(
//     (acc, staff) => acc + (staff.totalYearWork || 0),
//     0,
//   );

//   const handleYearChange = (event) => {
//     setReportsData(prev => ({ ...prev, year: event.target.value }));
//   };

//   const currentYear = new Date().getFullYear();
//   const years = Array.from({ length: 5 }, (_, i) => currentYear - i);

//   const handleMonthChange = (month) => {
//     if (month !== null) {
//       setSelectedMonth(month);
//     }
//   };

//   const handleAnalyticsMonthChange = (month) => {
//     if (month !== null) {
//       setSelectedAnalyticsMonth(month);
//     }
//   };

//   const handleMembershipPackageMonthChange = (month) => {
//     if (month !== null) {
//       setSelectedMembershipPackageMonth(month);
//     }
//   };

//   const selectedAnalyticsData = reportsData.monthlyAnalytics?.find(
//     (a) => a.month === selectedAnalyticsMonth,
//   );

//   const selectedMembershipPackageData = reportsData.membershipPackageAnalytics?.find(
//     (a) => a.month === selectedMembershipPackageMonth,
//   );

//   const CustomCardHeader = ({ title, subtitle, icon: Icon, color }) => {
//     const mainColor = theme.palette[color]?.main || theme.palette.primary.main;

//     return (
//       <Box
//         sx={{
//           display: 'flex',
//           alignItems: 'center',
//           gap: 2,
//           p: 1,
//           borderRadius: '12px',
//           color: '#ffffffff',
//           width: '100%',
//         }}
//       >
//         <Box
//           sx={{
//             width: 52,
//             height: 52,
//             borderRadius: '12px',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             background: mainColor,
//             color: '#fff',
//             boxShadow: `0 4px 12px ${mainColor}40`,
//           }}
//         >
//           <Icon size={26} />
//         </Box>
//         <Box>
//           <Typography variant="h5" fontWeight="700" color="inherit" sx={{ lineHeight: 1.2 }}>
//             {title}
//           </Typography>
//           <Typography variant="subtitle2" fontWeight="500" sx={{ opacity: 0.5 }}>
//             {subtitle}
//           </Typography>
//         </Box>
//       </Box>
//     );
//   };

//   return (
//     <PageContainer title="Reports" description="Salon performance reports">
//       <DashboardCard
//         title="Yearly Reports"
//         action={
//           <Select
//             value={reportsData.year}
//             onChange={handleYearChange}
//             sx={{
//               height: '40px',
//               minWidth: '120px',
//               backgroundColor: 'white',
//               border: '1px solid #e0e0e0',
//               borderRadius: '8px',
//             }}
//           >
//             {years.map((year) => (
//               <MenuItem key={year} value={year}>
//                 {year}
//               </MenuItem>
//             ))}
//           </Select>
//         }
//       >
//         {loading ? (
//           <ShowLoader />
//         ) : (
//           <Box>
//             <ReportSummaryCards
//               totalYearlySales={reportsData.totalYearlySales}
//               totalYearlyExpenses={reportsData.totalYearlyExpenses}
//               totalStaffWork={totalStaffWork}
//             />
//             <Grid container spacing={3}>
//               {/* Yearly Sales Chart */}
//               <Grid item xs={12}>
//                 <DashboardCard title={<CustomCardHeader title="Sales Overview" subtitle={`Yearly Report • ${reportsData.year}`} icon={FaChartLine} color="primary" />}>
//                   <YearlySalesChart salesData={reportsData.sales} year={reportsData.year} />
//                 </DashboardCard>
//               </Grid>

//               {/* Yearly Expenses Chart */}
//               <Grid item xs={12}>
//                 <DashboardCard title={<CustomCardHeader title="Expense Analysis" subtitle={`Yearly Report • ${reportsData.year}`} icon={FaWallet} color="error" />}>
//                   <YearlyExpensesChart expensesData={reportsData.expenses} year={reportsData.year} />
//                 </DashboardCard>
//               </Grid>

//               {/* Staff Performance Details */}
//               <Grid item xs={12}>
//                 <DashboardCard title={<CustomCardHeader title="Team Performance" subtitle="Monthly & Yearly Insights" icon={FaUsers} color="secondary" />}>
//                   <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1, flexWrap: 'wrap' }}>
//                     <ToggleButtonGroup
//                       value={selectedMonth}
//                       exclusive
//                       onChange={(e, val) => handleMonthChange(val)}
//                       aria-label="month selection"
//                     >
//                       {monthNames.map((m, i) => (
//                         <ToggleButton
//                           key={i}
//                           value={i + 1}
//                           sx={{ px: 3, py: 1, fontSize: '1rem', borderRadius: '20px !important', border: '1px solid !important', borderColor: `${theme.palette.divider} !important`, mx: 0.5, my: 0.5, '&.Mui-selected': { backgroundColor: theme.palette.primary.main, color: theme.palette.primary.contrastText, '&:hover': { backgroundColor: theme.palette.primary.dark } } }}
//                         >
//                           {m}
//                         </ToggleButton>
//                       ))}
//                     </ToggleButtonGroup>
//                   </Box>
//                   <Box sx={{ mb: 3 }}>
//                     <PerformerOfTheMonth
//                       staffMonthlyPerformance={reportsData.staffMonthlyPerformance}
//                       selectedMonth={selectedMonth}
//                     />
//                   </Box>
//                   <StaffPerformanceMonthlyView data={reportsData.staffMonthlyPerformance} selectedMonth={selectedMonth} onMonthChange={handleMonthChange} />
//                 </DashboardCard>
//               </Grid>

//               {/* Top Monthly Analytics */}
//               <Grid item xs={12}>
//                 <DashboardCard title={<CustomCardHeader title="Top Performers" subtitle="Services & Products Analytics" icon={FaStar} color="warning" />} sx={{ mb: 0, '& .MuiCardContent-root:last-child': { pb: 0 } }}>
//                   <Box sx={{ display: 'flex', justifyContent: 'center', mb: 8, flexWrap: 'wrap' }}>
//                     <ToggleButtonGroup
//                       value={selectedAnalyticsMonth}
//                       exclusive
//                       onChange={(e, val) => handleAnalyticsMonthChange(val)}
//                       aria-label="analytics month selection"
//                     >
//                       {monthNames.map((m, i) => (
//                         <ToggleButton 
//                           key={i} 
//                           value={i + 1}
//                           sx={{ px: 3, py: 1, fontSize: '1rem', borderRadius: '20px !important', border: '1px solid !important', borderColor: `${theme.palette.divider} !important`, mx: 0.5, my: 0.5, '&.Mui-selected': { backgroundColor: theme.palette.info.main, color: theme.palette.info.contrastText, '&:hover': { backgroundColor: theme.palette.info.dark } } }}
//                         >
//                           {m}
//                         </ToggleButton>
//                       ))}
//                     </ToggleButtonGroup>
//                   </Box>
//                   <TopAnalyticsCard analytics={selectedAnalyticsData} />
//                 </DashboardCard>
//               </Grid>

//               {/* Top Membership & Package Analytics */}
//               <Grid item xs={12}>
//                 <DashboardCard title={<CustomCardHeader title="Membership & Packages" subtitle="Membership & Package Analytics" icon={FaCrown} color="info" />} sx={{ mb: 0, '& .MuiCardContent-root:last-child': { pb: 0 } }}>
//                   <Box sx={{ display: 'flex', justifyContent: 'center', mb: 8, flexWrap: 'wrap' }}>
//                     <ToggleButtonGroup
//                       value={selectedMembershipPackageMonth}
//                       exclusive
//                       onChange={(e, val) => handleMembershipPackageMonthChange(val)}
//                       aria-label="membership package month selection"
//                     >
//                       {monthNames.map((m, i) => (
//                         <ToggleButton 
//                           key={i} 
//                           value={i + 1}
//                           sx={{ px: 3, py: 1, fontSize: '1rem', borderRadius: '20px !important', border: '1px solid !important', borderColor: `${theme.palette.divider} !important`, mx: 0.5, my: 0.5, '&.Mui-selected': { backgroundColor: theme.palette.info.main, color: theme.palette.info.contrastText, '&:hover': { backgroundColor: theme.palette.info.dark } } }}
//                         >
//                           {m}
//                         </ToggleButton>
//                       ))}
//                     </ToggleButtonGroup>
//                   </Box>
//                   <TopMembershipPackageAnalytics analytics={selectedMembershipPackageData} />
//                 </DashboardCard>
//               </Grid>
//             </Grid>
//           </Box>
//         )}
//       </DashboardCard>
//     </PageContainer>
//   );
// };

// export default Reports;
import React, { useState, useEffect } from 'react';
import {
  Grid,
  Typography,
  Box,
  ToggleButtonGroup,
  ToggleButton,
  useTheme,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  IconButton,
  InputAdornment,
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { FaChartLine, FaWallet, FaUsers, FaStar, FaCrown } from 'react-icons/fa';

import ReportSummaryCards from './components/ReportSummaryCards';
import PageContainer from 'src/components/container/PageContainer';
import DashboardCard from 'src/components/shared/DashboardCard';
import YearlySalesChart from './components/YearlySalesChart';
import YearlyExpensesChart from './components/YearlyExpensesChart';
import PerformerOfTheMonth from './components/PerformerOfTheMonth';
import StaffPerformanceMonthlyView from './components/StaffPerformanceTable';
import TopAnalyticsCard from './components/TopAnalyticsCard';
import TopMembershipPackageAnalytics from './components/TopMembershipPackageAnalytics';
import { useMain } from 'src/views/hooks/useMain';
import { fetchAOwner } from 'src/context/contextPages/AuthContexts';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import TextInputs from 'src/components/inputs/TextInputs';
import ExportReportDialog from './components/ExportReportDialog';
import { FaFileExport } from 'react-icons/fa'; // for the button icon


const Reports = () => {
  const theme = useTheme();

  const {
    monthwisesalesreport,
    monthwiseexpensereport,
    topperformer,
    staffperformance,
    topserviceproducts,
    topmembershippackages,
    activeBranchId,
    OwnerVarification,
    setShowMessage,
    ownerData,
    branchData,
    fetchAOwner: fetchAOwnerContext,
  } = useMain();

  const isMasked = branchData?.isMasked || false;

  /* MASK AUTH STATE */
  const [authOpen, setAuthOpen] = useState(false);
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isAuthorised, setIsAuthorised] = useState(false);
  const [authLoading, setAuthLoading] = useState(false);
  const [exportDialogOpen, setExportDialogOpen] = useState(false);
  const [hideDownloadButton, setHideDownloadButton] = useState(
    Boolean(ownerData?.hideDownloadButton)
  );

  useEffect(() => {
    if (ownerData && typeof ownerData.hideDownloadButton !== 'undefined') {
      setHideDownloadButton(ownerData.hideDownloadButton === true);
    }
  }, [ownerData]);

  useEffect(() => {
    const fetchOwnerDetails = async () => {
      try {
        const ownerId =
          ownerData?._id ||
          (localStorage.getItem('salon-admin')
            ? JSON.parse(localStorage.getItem('salon-admin'))
            : null);

        if (ownerId) {
          const fn = fetchAOwnerContext || fetchAOwner;
          if (fn) {
            const res = await fn(ownerId);
            const shouldHide = res?.data?.hideDownloadButton ?? res?.hideDownloadButton;
            if (typeof shouldHide !== 'undefined') {
              setHideDownloadButton(shouldHide === true);
            }
          }
        }
      } catch (error) {
        console.error('Error fetching owner data in Reports:', error);
      }
    };

    fetchOwnerDetails();
  }, [ownerData?._id]);

  useEffect(() => {
    if (branchData && typeof branchData.hideDownloadButton !== 'undefined') {
      if (branchData.hideDownloadButton === true) {
        setHideDownloadButton(true);
      }
    }
  }, [branchData]);

  /* CHECK STORED ACCESS */
  useEffect(() => {
    if (!isMasked) {
      setIsAuthorised(true);
      return;
    }

    const ts = localStorage.getItem('reportAccessTimestamp');
    if (ts && Date.now() - ts < 10 * 60 * 1000) {
      setIsAuthorised(true);
    } else {
      setAuthOpen(true);
    }
  }, [isMasked]);

  const handleCloseDialogue = () => {
    setAuthOpen(false);
    setPassword('');
    setShowPassword(false);
  };

  /* PASSWORD SUBMIT  */
  const handleAuthSubmit = async () => {
    if (!password) {
      setShowMessage({ message: 'Enter login password', messageType: 'error' });
      return;
    }

    try {
      setAuthLoading(true);
      const res = await OwnerVarification(ownerData?._id, { password });

      if (res?.statusCode === 200) {
        localStorage.setItem('reportAccessTimestamp', Date.now());
        setIsAuthorised(true);
        setAuthOpen(false);
        setPassword('');
        setShowPassword(false);
      } else {
        setShowMessage({ message: res?.message || 'Invalid password', messageType: 'error' });
      }
    } catch (err) {
      setShowMessage({ message: 'Something went wrong', messageType: 'error' });
    } finally {
      setAuthLoading(false);
    }
  };

  /*  MASK VALUE HELPER  */
  const maskValue = (value) => {
    if (!isMasked || isAuthorised) return value;
    if (value === null || value === undefined) return value;
    return '****';
  };

  /*  REPORT STATE  */
  const [reportsData, setReportsData] = useState({
    staffPerformance: [],
    sales: [],
    expenses: [],
    staffMonthlyPerformance: [],
    monthlyAnalytics: [],
    membershipPackageAnalytics: [],
    totalYearlySales: 0,
    totalYearlyExpenses: 0,
    year: new Date().getFullYear(),
  });

  const [loading, setLoading] = useState(true);
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
  const [selectedMembershipPackageMonth, setSelectedMembershipPackageMonth] = useState(new Date().getMonth() + 1);
  const [selectedAnalyticsMonth, setSelectedAnalyticsMonth] = useState(new Date().getMonth() + 1);

  const branchId = activeBranchId;

  /*  FETCH DATA */
  useEffect(() => {
    const fetchYearlyData = async () => {
      setLoading(true);

      const salesReport = await monthwisesalesreport(branchId, reportsData.year);
      const expenseReport = await monthwiseexpensereport(branchId, reportsData.year);
      const staffPerformanceReport = await staffperformance(branchId, reportsData.year);
      const topPerformerReport = await topperformer(branchId, reportsData.year);
      const topServiceProductsReport = await topserviceproducts(branchId, reportsData.year);
      const topMembershipPackagesReport = await topmembershippackages(branchId, reportsData.year);

      setReportsData({
        staffPerformance: topPerformerReport?.data?.staffPerformance || [],
        sales: salesReport?.data?.sales || [],
        expenses: expenseReport?.data?.expenses || [],
        staffMonthlyPerformance: staffPerformanceReport?.data?.staffPerformance || [],
        monthlyAnalytics: topServiceProductsReport?.data?.monthlyAnalytics || [],
        membershipPackageAnalytics: topMembershipPackagesReport?.data?.monthlyAnalytics || [],
        totalYearlySales: maskValue(salesReport?.data?.totalYearlySales || 0),
        totalYearlyExpenses: maskValue(expenseReport?.data?.totalYearlyExpenses || 0),
        year: salesReport?.data?.year || new Date().getFullYear(),
      });

      setLoading(false);
    };

    if (isAuthorised) fetchYearlyData();
  }, [branchId, reportsData.year, isAuthorised]);

  useEffect(() => {
    const fetchMonthlyData = async () => {
      if (!isAuthorised) return;
      const topPerformerReport = await topperformer(branchId, reportsData.year, selectedMonth);
      setReportsData((prev) => ({
        ...prev,
        staffPerformance: topPerformerReport?.data?.staffPerformance || [],
      }));
    };
    fetchMonthlyData();
  }, [branchId, reportsData.year, selectedMonth, isAuthorised]);

  const monthNames = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
  ];

  const currentYearNow = new Date().getFullYear();
  const currentMonthNow = new Date().getMonth() + 1;
  const isCurrentYearSelected = parseInt(reportsData.year) === currentYearNow;

  const handleYearChange = (event) => {
    setReportsData((prev) => ({ ...prev, year: event.target.value }));
  };

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 5 }, (_, i) => currentYear - i);

  const handleMonthChange = (event, month) => {
    if (month !== null) {
      setSelectedMonth(month);
    }
  };

  const handleAnalyticsMonthChange = (event, month) => {
    if (month !== null) {
      setSelectedAnalyticsMonth(month);
    }
  };

  const handleMembershipPackageMonthChange = (event, month) => {
    if (month !== null) {
      setSelectedMembershipPackageMonth(month);
    }
  };

  //  const handleCloseDialogue = () => {
  //   setAuthOpen(false);
  //   setPassword('');
  // };

  const selectedAnalyticsData = reportsData.monthlyAnalytics?.find(
    (a) => a.month === selectedAnalyticsMonth,
  );

  const selectedMembershipPackageData = reportsData.membershipPackageAnalytics?.find(
    (a) => a.month === selectedMembershipPackageMonth,
  );

  const CustomCardHeader = ({ title, subtitle, icon: Icon, color }) => {
    const mainColor = theme.palette[color]?.main || theme.palette.primary.main;

    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, p: 1, borderRadius: '12px', color: '#ffffffff', width: '100%' }}>
        <Box sx={{ width: 52, height: 52, borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: mainColor, color: '#fff', boxShadow: `0 4px 12px ${mainColor}40` }}>
          <Icon size={26} />
        </Box>
        <Box>
          <Typography variant="h5" fontWeight="700" color="inherit" sx={{ lineHeight: 1.2 }}>
            {title}
          </Typography>
          <Typography variant="subtitle2" fontWeight="500" sx={{ opacity: 0.5 }}>
            {subtitle}
          </Typography>
        </Box>
      </Box>
    );
  };

  /* BLOCK UI IF NOT AUTHORISED  */
  if (isMasked && !isAuthorised) {
    return (
      <>
        <Dialog open={authOpen} onClose={handleCloseDialogue}>
          <DialogTitle>Confirm Request</DialogTitle>
          <DialogContent>
            <DialogContentText>
             Please enter the owner password to access this page.
            </DialogContentText>
            <Box style={{ marginTop: '10px' }}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <TextInputs
                    title="Login Password"
                    name="password"
                    type={showPassword ? 'text' : 'password'}
                    value={password}
                    handleChange={(e) => setPassword(e.target.value)}
                    disabled={authLoading}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => setShowPassword((prev) => !prev)}
                            edge="end"
                            disabled={authLoading}
                          >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
              </Grid>
            </Box>
          </DialogContent>
          <DialogActions>
             <Button onClick={handleCloseDialogue}>Cancel</Button>
            <Button onClick={handleAuthSubmit} disabled={authLoading}>
              {authLoading ? 'Verifying...' : 'Submit'}
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }

  /*  NORMAL REPORT UI  */
  return (
    <PageContainer title="Reports" description="Salon performance reports">
      <DashboardCard
        title="Yearly Reports"
        action={
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          {!hideDownloadButton && (
            <Button
              variant="outlined"
              startIcon={<FaFileExport size={14} />}
              onClick={() => setExportDialogOpen(true)}
              sx={{
                height: '40px',
                backgroundColor: 'white',
                border: '1px solid #e0e0e0',
                borderRadius: '8px',
                color: '#333',

                '&:hover': {
                  backgroundColor: '#a0abf6',
                  color: '#fff',
                  borderColor: '#4b61df',
                },
              }}
            >
              Export Report
            </Button>
          )}
        
          <Select
            value={reportsData.year}
            onChange={handleYearChange}
            sx={{ height: '40px', minWidth: '120px', backgroundColor: 'white', border: '1px solid #e0e0e0', borderRadius: '8px' }}
          >
            {years.map((year) => (
              <MenuItem key={year} value={year}>
                {year}
              </MenuItem>
            ))}
          </Select>
        </Box>
      }
      >
        {loading ? <ShowLoader /> : (
          <>
            <ReportSummaryCards
              totalYearlySales={reportsData.totalYearlySales}
              totalYearlyExpenses={reportsData.totalYearlyExpenses}
              totalStaffWork={reportsData.staffMonthlyPerformance.reduce(
                (a, s) => a + (s.totalYearWork || 0), 0
              )}
            />
            <Grid container spacing={3} mt={2}>
              {/* Yearly Sales Chart */}
              <Grid item xs={12}>
                <DashboardCard title={<CustomCardHeader title="Sales Overview" subtitle={`Yearly Report • ${reportsData.year}`} icon={FaChartLine} color="primary" />}>
                  <YearlySalesChart salesData={reportsData.sales} year={reportsData.year} />
                </DashboardCard>
              </Grid>

              {/* Yearly Expenses Chart */}
              <Grid item xs={12}>
                <DashboardCard title={<CustomCardHeader title="Expense Analysis" subtitle={`Yearly Report • ${reportsData.year}`} icon={FaWallet} color="error" />}>
                  <YearlyExpensesChart expensesData={reportsData.expenses} year={reportsData.year} />
                </DashboardCard>
              </Grid>

              {/* Staff Performance Details */}
              <Grid item xs={12}>
                <DashboardCard title={<CustomCardHeader title="Team Performance" subtitle="Monthly & Yearly Insights" icon={FaUsers} color="secondary" />}>
                  <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1, flexWrap: 'wrap' }}>
                    <ToggleButtonGroup
                      value={selectedMonth}
                      exclusive
                      onChange={handleMonthChange}
                      aria-label="month selection"
                    >
                     {monthNames.map((m, i) => {
                        if (isCurrentYearSelected && (i + 1) > currentMonthNow) return null;
                        return (
                          <ToggleButton
                            key={i}
                            value={i + 1}
                            sx={{ px: 3, py: 1, fontSize: '1rem', borderRadius: '20px !important', border: '1px solid !important', borderColor: `${theme.palette.divider} !important`, mx: 0.5, my: 0.5, '&.Mui-selected': { backgroundColor: theme.palette.primary.main, color: theme.palette.primary.contrastText, '&:hover': { backgroundColor: theme.palette.primary.dark } } }}
                          >
                            {m}
                          </ToggleButton>
                        );
                      })} 
                    </ToggleButtonGroup>
                  </Box>
                  <Box sx={{ mb: 3 }}>
                    <PerformerOfTheMonth
                      staffMonthlyPerformance={reportsData.staffPerformance}
                      selectedMonth={selectedMonth}
                    />
                  </Box>
                  <StaffPerformanceMonthlyView data={reportsData.staffMonthlyPerformance} selectedMonth={selectedMonth} onMonthChange={handleMonthChange} />
                </DashboardCard>
              </Grid>

              {/* Top Monthly Analytics */}
              <Grid item xs={12}>
                <DashboardCard title={<CustomCardHeader title="Top Performers" subtitle="Services & Products Analytics" icon={FaStar} color="warning" />} sx={{ mb: 0, '& .MuiCardContent-root:last-child': { pb: 0 } }}>
                  <Box sx={{ display: 'flex', justifyContent: 'center', mb: 8, flexWrap: 'wrap' }}>
                    <ToggleButtonGroup
                      value={selectedAnalyticsMonth}
                      exclusive
                      onChange={handleAnalyticsMonthChange}
                      aria-label="analytics month selection"
                    >
                      {monthNames.map((m, i) => {
                        if (isCurrentYearSelected && (i + 1) > currentMonthNow) return null;
                        return (
                          <ToggleButton 
                            key={i} 
                            value={i + 1}
                            sx={{ px: 3, py: 1, fontSize: '1rem', borderRadius: '20px !important', border: '1px solid !important', borderColor: `${theme.palette.divider} !important`, mx: 0.5, my: 0.5, '&.Mui-selected': { backgroundColor: theme.palette.info.main, color: theme.palette.info.contrastText, '&:hover': { backgroundColor: theme.palette.info.dark } } }}
                          >
                            {m}
                          </ToggleButton>
                        );
                      })}
                    </ToggleButtonGroup>
                  </Box>
                  <TopAnalyticsCard analytics={selectedAnalyticsData} />
                </DashboardCard>
              </Grid>

              {/* Top Membership & Package Analytics */}
              <Grid item xs={12}>
                <DashboardCard title={<CustomCardHeader title="Membership & Packages" subtitle="Membership & Package Analytics" icon={FaCrown} color="info" />} sx={{ mb: 0, '& .MuiCardContent-root:last-child': { pb: 0 } }}>
                  <Box sx={{ display: 'flex', justifyContent: 'center', mb: 8, flexWrap: 'wrap' }}>
                    <ToggleButtonGroup
                      value={selectedMembershipPackageMonth}
                      exclusive
                      onChange={handleMembershipPackageMonthChange}
                      aria-label="membership package month selection"
                    >
                      {monthNames.map((m, i) => {
                        if (isCurrentYearSelected && (i + 1) > currentMonthNow) return null;
                        return (
                          <ToggleButton 
                            key={i} 
                            value={i + 1}
                            sx={{ px: 3, py: 1, fontSize: '1rem', borderRadius: '20px !important', border: '1px solid !important', borderColor: `${theme.palette.divider} !important`, mx: 0.5, my: 0.5, '&.Mui-selected': { backgroundColor: theme.palette.info.main, color: theme.palette.info.contrastText, '&:hover': { backgroundColor: theme.palette.info.dark } } }}
                          >
                            {m}
                          </ToggleButton>
                        );
                      })}
                    </ToggleButtonGroup>
                  </Box>
                  <TopMembershipPackageAnalytics analytics={selectedMembershipPackageData} />
                </DashboardCard>
              </Grid>
            </Grid>
          </>
        )}
      </DashboardCard>
      {!hideDownloadButton && (
        <ExportReportDialog
          open={exportDialogOpen}
          onClose={() => setExportDialogOpen(false)}
          branchId={branchId}
        />
      )}
      
    </PageContainer>
    
  );
};

export default Reports;